import { render, staticRenderFns } from "./FormatAlertTool.vue?vue&type=template&id=71faa7de&scoped=true&"
import script from "./FormatAlertTool.vue?vue&type=script&lang=ts&"
export * from "./FormatAlertTool.vue?vue&type=script&lang=ts&"
import style0 from "./FormatAlertTool.vue?vue&type=style&index=0&id=71faa7de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71faa7de",
  null
  
)

export default component.exports